const messages: Record<string, string> = {
	'landing.termsAndConditionsLink':
		'Zaakceptuj regulamin, politykę prywatności i obowiązek informacyjny',

	'invalidFile.size.title': 'Nieprawidłowy rozmiar zdjęcia',
	'invalidFile.size.description': 'Zdjęcie jest większe niż maksymalny dozwolony rozmiar.',
	'invalidFile.extension.title': 'Nieobsługiwany typ pliku',
	'invalidFile.extension.description':
		'Podany typ pliku nie jest obsługiwany. Obsługiwane typy plików: .jpg, .jpeg, .jfif, .heic, .heif, .png oraz .bmp',
};

export default messages;
